import React from "react";

function Payment() {
  return (
    <>
      <section className="services" id="payment">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>Our Services</h2>
              </div>
            </div>
            <div className=" col-md-6 bgcolor text-margin">
              <div className="text-center text-margin">
                <h4 className="text-center text-color">
                  <b>PAYMENT GATEWAY</b>

                  <p className="text-margin">
                    <b>
                      In India, 53 Billion Digital Transactions Were Recorded in
                      2021!
                    </b>
                  </p>
                </h4>
                <p className="text-margin">
                  A secure and convenient payment gateway has emerged as a
                  necessity for most e-retailers, as it helps them boost their
                  customer loyalty and profits. Macrozion Techsystems
                  specializes in customized and high-quality payment gateway
                  integration services. Our experienced developers can integrate
                  various payment gateways to your existing store to make it
                  compatible with all major credit and debit cards in the world.
                  Our professionals possess expertise in SSL and PCI compliant
                  integration, hosted payment and API integration, and more.
                  They have integrated 30+ payment gateway modules for
                  WordPress, Drupal, Shopify, Magento, Prestashop, etc.
                </p>
                {/* <p className="text-margin"></p> */}

                <h5 className="text-color">
                  <b>Our Payment Gateway Integration Expertise</b>
                </h5>
                <ul className="text-color text-margin">
                  <li>
                    <b> 1. </b> Secured payment integration to your website or
                    mobile application
                  </li>
                  <li>
                    <b> 2. </b> Multi-currency conversions
                  </li>
                  <li>
                    <b> 3. </b> Magento Development
                  </li>
                  <li>
                    <b> 4. </b>
                    Shopping cart integration and transaction-related support
                  </li>
                  <li>
                    <b> 5. </b> Technical support and customer care services
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-5">
              <p>
                <img
                  src="./images/payment.png"
                  alt="Example1"
                  width="460"
                  height="520"
                ></img>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Payment;
